import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { Helmet } from "react-helmet-async";

import { getListExportInfo, List } from "~/features/export-info";
import { ErrorElement } from "~/components/ErrorElement";

const exportSearchSchema = z.object({
  page: z.number().catch(1),
  limit: z.number().catch(9),
  keyword: z.string().catch(""),
});

type ExportSearch = z.infer<typeof exportSearchSchema>;

export const Route = createFileRoute("/_layout/export-info/")({
  validateSearch: (search: Record<string, unknown>): ExportSearch => exportSearchSchema.parse(search),
  loaderDeps: ({ search: { keyword, limit, page } }) => ({ keyword, limit, page }),
  loader: ({ context: { queryClient }, deps: { page, limit, keyword } }) =>
    queryClient.ensureQueryData(getListExportInfo({ page, limit, keyword })),
  gcTime: 0,
  shouldReload: false,
  errorComponent: () => <ErrorElement statusCode="500" />,
  notFoundComponent: () => <ErrorElement statusCode="404" />,
  component: () => (
    <>
      <Helmet>
        <title>Informasi Ekspor - Ecobiz</title>
      </Helmet>
      <List />
    </>
  ),
});
